module.exports = __webpack_public_path__ + "static/media/a1p.ac6893cc.jpg";